import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to formulate action plans.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>isn't it interesting?
                                            </div>
                                            <p>Everyone loves mazes. But what is the best plan of action in
                                                finding your way out of a maze?
                                                Try out this one below:</p>
                                            <div className="innovativeimg">

                                                <img
                                                    src={require('@images/maze.png')}
                                                    alt=""/>

                                            </div>

                                            <div className="border_subtitle">So what strategy did you use, if
                                                you used one at all?
                                            </div>
                                            <div className="paraspace"><p>Most people tend to either work
                                                through from the entrance to the exit using a process of trial
                                                and
                                                error or work back from the exit. You are likely to be engaging
                                                the logical part of your brain to work
                                                out a route to follow. When you take a wrong turn you will make
                                                a mental note not to repeat the
                                                error. When you are physically in a maze you will form a mental
                                                picture of your position and use this
                                                as a guide. This requires you to form a mental map which can be
                                                hard to maintain and update when
                                                you keep adding new information. So what would make life
                                                easier?</p></div>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}